import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function cov_1x2xuaq99b() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/growth/auth/LocalizationContext.tsx";
  var hash = "31c57441b2debfd5092b25a97ab88aa07e203228";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/growth/auth/LocalizationContext.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 28
        },
        end: {
          line: 14,
          column: 2
        }
      },
      "1": {
        start: {
          line: 16,
          column: 85
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "2": {
        start: {
          line: 20,
          column: 28
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "3": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 29,
          column: 15
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 28,
          column: 5
        }
      },
      "5": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 22
        }
      },
      "6": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 61
        }
      },
      "7": {
        start: {
          line: 25,
          column: 45
        },
        end: {
          line: 25,
          column: 59
        }
      },
      "8": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 21
        }
      },
      "9": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 26
        }
      },
      "10": {
        start: {
          line: 31,
          column: 14
        },
        end: {
          line: 31,
          column: 26
        }
      },
      "11": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 37,
          column: 4
        }
      },
      "12": {
        start: {
          line: 40,
          column: 31
        },
        end: {
          line: 40,
          column: 68
        }
      },
      "13": {
        start: {
          line: 40,
          column: 37
        },
        end: {
          line: 40,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 85
          },
          end: {
            line: 16,
            column: 86
          }
        },
        loc: {
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 12
          },
          end: {
            line: 22,
            column: 13
          }
        },
        loc: {
          start: {
            line: 22,
            column: 18
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 22
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 39
          },
          end: {
            line: 25,
            column: 40
          }
        },
        loc: {
          start: {
            line: 25,
            column: 45
          },
          end: {
            line: 25,
            column: 59
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 31
          },
          end: {
            line: 40,
            column: 32
          }
        },
        loc: {
          start: {
            line: 40,
            column: 37
          },
          end: {
            line: 40,
            column: 68
          }
        },
        line: 40
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        }, {
          start: {
            line: 26,
            column: 11
          },
          end: {
            line: 28,
            column: 5
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 26
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 31
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "31c57441b2debfd5092b25a97ab88aa07e203228"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1x2xuaq99b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1x2xuaq99b();
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useContext, useEffect, useState } from 'react';
import i18n from "../../i18n/index.mjs";
var LocalizationContext = (cov_1x2xuaq99b().s[0]++, /*#__PURE__*/createContext({
  locale: 'en-US',
  ready: false
}));
cov_1x2xuaq99b().s[1]++;
export var LocalizationProvider = function LocalizationProvider(_ref) {
  var locale = _ref.locale,
    children = _ref.children;
  cov_1x2xuaq99b().f[0]++;
  var _ref2 = (cov_1x2xuaq99b().s[2]++, useState(i18n.language === locale)),
    _ref3 = _slicedToArray(_ref2, 2),
    ready = _ref3[0],
    setReady = _ref3[1];
  cov_1x2xuaq99b().s[3]++;
  useEffect(function () {
    cov_1x2xuaq99b().f[1]++;
    cov_1x2xuaq99b().s[4]++;
    if (i18n.language !== locale) {
      cov_1x2xuaq99b().b[0][0]++;
      cov_1x2xuaq99b().s[5]++;
      setReady(false);
      cov_1x2xuaq99b().s[6]++;
      i18n.changeLanguage(locale).then(function () {
        cov_1x2xuaq99b().f[2]++;
        cov_1x2xuaq99b().s[7]++;
        return setReady(true);
      });
    } else {
      cov_1x2xuaq99b().b[0][1]++;
      cov_1x2xuaq99b().s[8]++;
      setReady(true);
    }
  }, [locale]);
  cov_1x2xuaq99b().s[9]++;
  if (!ready) {
    cov_1x2xuaq99b().b[1][0]++;
    cov_1x2xuaq99b().s[10]++;
    return null;
  } else {
    cov_1x2xuaq99b().b[1][1]++;
  }
  cov_1x2xuaq99b().s[11]++;
  return /*#__PURE__*/React.createElement(LocalizationContext.Provider, {
    value: {
      locale: locale,
      ready: ready
    }
  }, children);
};
cov_1x2xuaq99b().s[12]++;
export var useLocalization = function useLocalization() {
  cov_1x2xuaq99b().f[3]++;
  cov_1x2xuaq99b().s[13]++;
  return useContext(LocalizationContext);
};
//# sourceMappingURL=LocalizationContext.mjs.map